window.addEventListener("turbo:load", function(event) {
  // Mark or unmark all checkboxes classified 'record_mark'
  $('#mark_all').click(function(event) {
    $("input[type='checkbox'].record_mark").prop('checked', true)
  });
  $('#unmark_all').click(function(event) {
    $("input[type='checkbox'].record_mark").prop('checked', false)
  });
});